module.exports = __webpack_public_path__ + "img/arrow-right-line.7922640a.svg";